import { make } from './Popover.gen'

type PopoverProps = React.ComponentProps<typeof make>

const Popover = make as React.FunctionComponent<PopoverProps>

export { Popover, type PopoverProps }
